'use client';

import { type RefObject, useEffect, useRef } from 'react';

/** Calls `onReset` when the input's form is reset: `form.reset()` restores the
 *  DOM, not the React state behind a controlled field. */
export function useFormReset(inputRef: RefObject<HTMLInputElement | null>, onReset: () => void) {
    const onResetRef = useRef(onReset);

    useEffect(() => {
        onResetRef.current = onReset;
    });

    // Re-bound after every render: the input element changes with the pointer type.
    useEffect(() => {
        const form = inputRef.current?.form;
        if (!form) return;

        const handleReset = () => onResetRef.current();
        form.addEventListener('reset', handleReset);

        return () => form.removeEventListener('reset', handleReset);
    });
}
